import React from 'react';

const Pagination = ({ nPages, currentPage, setCurrentPage }) => {
    if (nPages === 0) return null; // Hide pagination if no pages

    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    const goToNextPage = () => {
        if (currentPage < nPages) setCurrentPage(currentPage + 1);
    };
    const goToPrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    return (
        <nav>
            <ul className='pagination justify-content-end mt-3 gap-10'>
                {/* Previous Button */}
                <li className={`page-item page-btn ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a 
                        className="page-link"
                        onClick={goToPrevPage}
                        href="#"
                        aria-disabled={currentPage === 1}
                        style={currentPage === 1 ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    >
                        <i className={`fa fa-angle-left ${currentPage === 1 ? 'disabled-icon' : ''}`}></i>
                    </a>
                </li>

                {/* Page Numbers */}
                {pageNumbers.map(pgNumber => (
                    <li key={pgNumber} className={`page-item ${currentPage === pgNumber ? 'active' : ''}`}>
                        <a onClick={() => setCurrentPage(pgNumber)} className='page-link' href='#'>
                            {pgNumber}
                        </a>
                    </li>
                ))}

                {/* Next Button */}
                <li className={`page-item page-btn ${currentPage === nPages ? 'disabled' : ''}`}>
                    <a 
                        className="page-link"
                        onClick={goToNextPage}
                        href="#"
                        aria-disabled={currentPage === nPages}
                        style={currentPage === nPages ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    >
                        <i className={`fa fa-angle-right ${currentPage === nPages ? 'disabled-icon' : ''}`}></i>
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
